import { useEffect, useState } from "react";
import "./OptionPicker.scss";
import Select, { components } from "react-select";
import { ColorTheme } from "/Models/Models/ColorTheme";
import OptionPickerInput, { OptionPickerInputStyle } from "./OptionPickerInput";
import OptionPickerDropdownIndicator from "./OptionPickerDropdownIndicator";
import { ReactSelectItem } from "/Helpers/ReactSelectItem";
import { CaretDownIcon } from "/App.Components";
export interface OptionPickerProps {
  activeItem: ReactSelectItem;
  items: ReactSelectItem[];
  dropdownId: string;
  onOptionClick: (clickedLabel: string) => void;
}

const OptionPicker = ({
  activeItem,
  items,
  dropdownId,
  onOptionClick,
}: OptionPickerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentItem] = useState(activeItem);
  const [initialized, setInitialized] = useState(false);
  const [options, setOptions] = useState<ReactSelectItem[]>(
    items.filter((x) => x.label !== activeItem.label),
  );

  const handleChange = (newCurrentItem: ReactSelectItem) => {
    setOptions(items.filter((x) => x.label !== newCurrentItem.label));
    onOptionClick(newCurrentItem.label);
  };

  useEffect(() => setInitialized(true), []);

  return !initialized ? (
    <div className="option-picker-norad">
      <div className="option-picker-norad__ssr-placeholder">
        {currentItem?.label}
        <div className="option-picker-norad__ssr-placeholder-caret">
          <CaretDownIcon size="24" thickness="Reg" />
        </div>
      </div>
    </div>
  ) : (
    <Select
      components={{
        IndicatorSeparator: null,
        DropdownIndicator: (props) => (
          <OptionPickerDropdownIndicator
            isOpen={isOpen}
            reactSelectProps={props}
          />
        ),
        Input: (props) => (
          <OptionPickerInput
            reactSelectProps={props}
            dropdownId={dropdownId}
            currentItem={currentItem}
          />
        ),
        MenuList: (menuList) => (
          <components.MenuList
            {...menuList}
            innerProps={{
              id: `dropdown-content-${dropdownId}`,
              role: "listbox",
            }}
          />
        ),
      }}
      className="option-picker-norad"
      classNamePrefix="option-picker-norad"
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          backgroundColor: "#f2eceb",
          height: "2.5rem",
          border: state.isFocused
            ? `1px solid ${ColorTheme.burgundy17}`
            : "1px solid grey",
          boxShadow: state.isFocused
            ? `0 0 0 2px ${ColorTheme.burgundy17}`
            : "none",
        }),
        input: OptionPickerInputStyle.input,

        singleValue: (baseStyles) => ({
          ...baseStyles,
          color: ColorTheme.iconStrong,
          zIndex: 1,
        }),

        menuList: (baseStyles) => ({
          ...baseStyles,
          backgroundColor: "#f2eceb",
          padding: "unset",
        }),
        option: (baseStyles, state) => ({
          ...baseStyles,
          backgroundColor: "#f2eceb",
          boxShadow: state.isFocused
            ? `inset 0 0 0 3px ${ColorTheme.burgundy17}`
            : "none",
        }),
      }}
      onChange={(x) => handleChange(x as ReactSelectItem)}
      defaultValue={currentItem}
      isDisabled={false}
      isLoading={false}
      isClearable={false}
      onMenuOpen={() => setIsOpen(true)}
      onMenuClose={() => setIsOpen(false)}
      options={options}
    />
  );
};
export default OptionPicker;
